import { useSelector } from "react-redux"
import DatePicker from "react-datepicker";
import { parseISO, isValid } from 'date-fns';

import "react-datepicker/dist/react-datepicker.css";
import './Input.scss'

export const MCCheckbox = ({ className = "", onChange = () => { }, ...rest }) => {
  return (
    <input
      type="checkbox"
      className={`form-check-input ${className}`}
      onChange={onChange}
      {...rest} 
    />
  );
}


export const MCRadio = ({ className = "", onChange = () => { }, ...rest }) => {
  return (
    <input
      type="radio"
      className={`form-check-input ${className}`}
      onChange={onChange}
      {...rest}
    />
  )
}


export const MCInput = ({ type = "text", className = "", isValid = true, onChange = () => {}, selected, ...rest }) => {

  const { gTheme } = useSelector(state => state.theme);

  const buildClassName = () => {
    let classNameString = className;
    if (gTheme === "dark") classNameString += ` ${gTheme}`;
    if (!isValid) classNameString += " is-invalid";
    return classNameString;
  }

  const parseDate = (value) => {
    if (!value) return null;
    if (value instanceof Date) return value;
    const parsedDate = parseISO(value);
    return parsedDate;
  };


  if (type === "textarea") {
    return (
      <textarea
        type="text"
        className={`form-control ${buildClassName()}`}
        onChange={onChange}
        {...rest}
      />
    )
  }

  if (type === "date") {
    const parsedDate = parseDate(selected);
    return (
      <DatePicker
        className={`${buildClassName()}`}
        selected={parsedDate}
        dateFormat="dd/MM/yy"
        onChange={onChange}
        {...rest}
      />
    )
  }

  return (
    <input
      type={type}
      className={`form-control ${buildClassName()}`}
      onChange={onChange}
      {...rest}
    />
  )
}

